import { React, PT, fetchApi, connect, withRouter } from '@gasbuddy/react';
import { Input, Modal, Header, Form, Button, Icon, Message, List } from 'semantic-ui-react';

class BaseMoveModal extends React.Component {
  state = {}

  loadAndGo = () => {
    this.setState({ opened: true });
  }

  getUserPreview = () => {
    const { dstAccount } = this.state;
    this.setState({ }, async () => {
      const { body, status, error } = await fetchApi({
        url: '/identity/user',
        catchErrors: true,
        body: {
          accountId: dstAccount,
          data: ['id', 'profile'],
        },
      });
      if (error || status !== 200) {
        this.setState({ error: body || error });
      } else {
        this.setState({ opened: true, dstIdent: body.ident, error: null });
      }
    });
  }

  callApi = () => {
    const { dstAccount } = this.state;
    const { accountId, transactionId, history } = this.props;
    this.setState({ }, async () => {
      const { body, status, error } = await fetchApi({
        url: `/payments/transaction/${accountId}/${transactionId}/move`,
        catchErrors: true,
        body: {
          dstAccount,
        },
      });
      if (error || status !== 200) {
        this.setState({ error: body || error });
      } else {
        history.replace(`/payments/transaction/${dstAccount}/${transactionId}`); //
        this.setState({ opened: false, error: null });
      }
    });
  }

  render() {
    const { opened, dstAccount, dstIdent, error } = this.state;
    const memberName = dstIdent && dstIdent.find(i => i.namespace === 'member_name');
    const email = dstIdent && dstIdent.find(i => !i.deleted_at && i.type === 'email');
    const previewing = memberName && email;
    return (
      <Modal
        open={opened}
        trigger={<Button onClick={this.loadAndGo}>Move Transaction</Button>}
      >
        <Header icon="attention" content="Enter the account ID to move the transaction to" />
        <Modal.Content>
          {dstIdent
            && (
            <Message>
              <Message.Content>
                <List>
                  <List.Header>Moving to account:</List.Header>
                  <List.Item>
                    Account Number:
                    &nbsp;
                    {dstAccount}
                  </List.Item>
                  <List.Item>
                    Member Name:
                    &nbsp;
                    {memberName && memberName.identifier}
                  </List.Item>
                  <List.Item>
                    Email:
                    &nbsp;
                    {email && email.identifier}
                  </List.Item>
                </List>
              </Message.Content>
            </Message>
            )
          }
          {error
            && (
            <Message negative>
              <Message.Content>
                <List>
                  <List.Header>Cannot move transaction:</List.Header>
                  {(error.log || []).map(l => (
                    <List.Item>
                      {l.message}
&nbsp;
                      {l.value && `(${l.value})`}
                    </List.Item>
                  ))}
                </List>
              </Message.Content>
            </Message>
            )
          }
          <Form>
            <Form.Field>
              <Input
                type="number"
                name="dstAccount"
                value={dstAccount}
                onChange={(e, { value }) => this.setState({ dstAccount: value, dstIdent: null })}
                placeholder="The account to move the transaction"
              />
            </Form.Field>
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button basic color="grey" onClick={() => this.setState({ opened: false })}>
            <Icon name="minus" />
            {' '}
            Cancel
          </Button>
          <Button basic color="blue" onClick={this.getUserPreview}>
            <Icon name="eye" />
            {' '}
            Preview Move
          </Button>
          {previewing
            && (
            <Button basic color="red" onClick={this.callApi}>
              <Icon name="money" />
              {' '}
              Move Transaction to Account
              {' '}
              {dstAccount}
            </Button>
            )
          }
        </Modal.Actions>
      </Modal>
    );
  }
}

BaseMoveModal.propTypes = {
  history: PT.shape({ replace: PT.func, push: PT.func }).isRequired,
  accountId: PT.number,
  transactionId: PT.number,
};

BaseMoveModal.defaultProps = {
  transactionId: 0,
  accountId: 0,
};

export const MoveModal = withRouter(connect(() => {})(BaseMoveModal));
